import {Col, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Back from "../layout/template/back";
import {Link, useParams} from "react-router-dom";
import AppRoute from "../../utils/AppRoute";
import ApiService from "../../services/ApiService";

const Pool = () => {
    const {piscinaId} = useParams();
    const [piscina, setPiscina] = useState();
    const [imageUrl, setImageUrl] = useState();

    useEffect(() => {
        console.log("PiscinaID: " +piscinaId);

        ApiService.getPoolById(piscinaId)
            .then(piscinaData => {
                setPiscina(piscinaData);
                ApiService.getPoolImageById(piscinaData.id).then(response => {
                    if(response.ok){
                        response.blob().then(imageBlob => {
                            const url = URL.createObjectURL(imageBlob);
                            setImageUrl(url);
                        })
                    }
                })

            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getAddressDataByType = (addressType) =>{
        let splittedData = piscina.place.split(";");

        switch (addressType){
            case 0:
                return splittedData[addressType];
            case 1:
                return splittedData[addressType];
            case 2:
                return splittedData[addressType];
            default:
                return "";
        }
    }

    function handleOpenRule(e) {
        e.preventDefault();
        if(piscina.rules !== ""){
            window.open(piscina.rules, "_blank");
        }
    }

    return (
            <>
                {piscina && <Row className={'justify-content-between'}>

                    {/*side left*/}
                    <Col xs={12} lg={6}>
                        <Row>
                            <Col>
                                <Back />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <div className={'title-page-section mt-5 header-detail'}>
                                    <h2 className={'title title-rotate'}>{piscina.title}</h2>
                                </div>
                            </Col>
                        </Row>
                        <Row className={'mb-3'}>
                            <Col>
                                {/*<div className={'paragraph-section'}>
                                    <p className={'fw-bold mb-0'}>Descrizione:</p>
                                    <p>Descrizione piscina, caratteristiche...</p>
                                </div>*/}

                                <div className={'paragraph-section'}>
                                    <p className={'fw-bold mb-0'}>Locazione:</p>
                                    <p className={'mb-0'}>{`${getAddressDataByType(0)}, ${getAddressDataByType(1)}`}</p>
                                    <p><a href={getAddressDataByType(2)} target={'_blank'} rel="noreferrer"><i className={"icon arrow me-1"} />apri in Google Maps</a></p>
                                </div>

                                <div className={'paragraph-section'}>
                                    <p className={'fw-bold mb-0'}>Regolamento piscina:</p>
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <p><a href="#" onClick={handleOpenRule} rel="noreferrer">documento</a></p>
                                </div>

                                <div className={'paragraph-section'}>
                                    <p><Link to={AppRoute.BASE} state={{selectedPool: piscinaId}} className={'fw-bold'}><i className={"icon arrow me-1"} />Scopri tutti i corsi della piscina {piscina.title}</Link></p>
                                </div>

                            </Col>
                        </Row>
                    </Col>
                    {/* end side left*/}

                    {/*side right*/}
                    <Col xs={12} lg={5}>

                        {imageUrl ? (
                                <img alt={"pool of minusio"} src={imageUrl} className={"img-fluid"} />
                            ) :
                            <img alt={'pool of minusio'} src={'https://images.unsplash.com/photo-1614667288602-9ac6e37318a7?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3348&q=80'} className={'img-fluid'}/>
                        }

                    </Col>
                    {/*side right*/}
                </Row>}
            </>

        );
}

export default Pool;
